import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {  Button } from 'react-bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';
import { formatDate } from '../../../utils/dateUtils';

const Guest = () => {
    const navigate = useNavigate();
    const debounceTimeout = useRef(null);
    const [guests, setGuests] = useState([]);
    const [properties, setProperties] = useState([]);
    const [floors, setFloors] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0, totalPages: 1 });
   
    const [filter, setFilter] = useState({
        guest_name: '',
        property_id: '',
        floor_id: '',
        room_id: '',
    });


   
 

      const getGuests = async () => {
        setIsLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-previous-guests`, {
                params: {
                    page: pagination.page,
                    limit: pagination.limit,
                    guest_name: filter.guest_name,
                    property_id: filter.property_id,
                    floor_id: filter.floor_id,
                    room_id: filter.room_id,
                },
                withCredentials: true
            });

            if (res.data.status) {
                setGuests(res.data.guests || []);
                setPagination(res.data.pagination);
            } else {
                setGuests([]);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getProperties();
        getFloors();
        getRooms();
       
    }, []);

    useEffect(() => {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            getGuests();
        }, 500);
        return () => clearTimeout(debounceTimeout.current);
    }, [pagination.page, filter]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter(prev => {
            const updated = { ...prev, [name]: value };
            if (name === "property_id") {
                updated.floor_id = "";
                updated.room_id = "";
                setFloors([]);
                setRooms([]);
                getFloors(value);
            } else if (name === "floor_id") {
                updated.room_id = "";
                setRooms([]);
                getRooms(value);
            }
            return updated;
        });
        setPagination(prev => ({ ...prev, page: 1 }));

    };

   
  
    const clearFilter = () => {
        setFilter({ guest_name: '', property_id: '', floor_id: '', room_id: '' });
        setPagination(prev => ({ ...prev, page: 1 }));
    };

    const getProperties = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-properties`, { withCredentials: true });
            if (res.data.status) {
                setProperties(res.data.properties || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    const getFloors = async (propertyId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-floors?property_id=${propertyId}`, { withCredentials: true });
            if (res.data.status) {
                setFloors(res.data.floors || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    const getRooms = async (floorId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-rooms?floor_id=${floorId}`, { withCredentials: true });
            if (res.data.status) {
                setRooms(res.data.rooms || []);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        }
    };

    return (
        <div className="container-fluid px-4 mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Manage Guests</h3>
            </div>

            <div className="d-flex align-items-center mb-3">
                <Button variant="outline-dark" type="button"  onClick={() => navigate('/admin/guest-management/guest')} className="rounded-pill me-2" >Current</Button>
                <Button variant="dark" type="button"  onClick={() => navigate('/admin/guest-management/guest-previous')} className="rounded-pill" >Previous</Button>
             </div>

            <div className="card shadow mt-4">
                <div className="card-header">
                    <h5 className="mb-0">Search Guests</h5>
                </div>
                <div className="card-body p-4">
                    {/* Filter Section */}
                    <div className="row align-items-end g-2 mb-4">
                        <div className="col-md-3">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control ps-3 pe-5 rounded-3"
                                    placeholder="Search Guest"
                                    name="guest_name"
                                    value={filter.guest_name || ''}
                                    onChange={handleFilterChange}
                                />
                                <i
                                    className="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
                                    style={{ pointerEvents: 'none' }}
                                ></i>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <select
                                className="form-select rounded-3"
                                name="property_id"
                                value={filter.property_id}
                                onChange={handleFilterChange}
                            >
                                <option value="">Select Property</option>
                                {properties.map(p => (
                                    <option key={p.id} value={p.id}>{p.property_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <select
                                className="form-select rounded-3"
                                name="floor_id"
                                value={filter.floor_id}
                                onChange={handleFilterChange}
                            >
                                <option value="">Select Floor</option>
                                {floors.map(f => (
                                    <option key={f.id} value={f.id}>{f.floor_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select
                                className="form-select rounded-3"
                                name="room_id"
                                value={filter.room_id}
                                onChange={handleFilterChange}
                            >
                                <option value="">Select Room</option>
                                {rooms.map(r => (
                                    <option key={r.id} value={r.id}>{r.room_no}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-1 d-flex">
                            <button type="button" className="btn btn-dark w-100 rounded-3" onClick={clearFilter}>
                                Clear
                            </button>
                        </div>
                    </div>

                    {/* Guest Table */}

                    <div className="table-responsive">
                        <table className="table table-bordered table-hover shadow-sm nowrap">
                            <thead className="table-success">
                                <tr>
                                    <th>Guest ID</th>
                                    <th>Name</th>
                                    <th>Contact Info</th>
                                    <th>Phase</th>
                                    <th>Bed</th>
                                    <th>Floor</th>
                                    <th>Property</th>
                                    <th>Unit Rate</th>
                                    <th>Move-in Date</th>
                                    <th>Move-out Date</th>

                                    <th>Job Due Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan="11">Loading...</td></tr>
                                ) : guests.length === 0 ? (
                                    <tr><td colSpan="11">No data found.</td></tr>
                                ) : (
                                    guests.map(g => (
                                        <tr key={g.id}>
                                            <td>{`BBM${String(g.id).padStart(4, '0')}`}</td>
                                            <td>{g.name}</td>
                                            <td>{`${g.phone ? g.phone + ' ' : ''}${g.email}`}</td>
                                            <td>{g.phase_title}</td>
                                            <td>{g.bedtype}</td>
                                            <td>{g.floor_name}</td>
                                            <td>{g.property_name}</td>
                                            <td>{g.rate != null && !isNaN(g.monthly_rate) ? `$${parseFloat(g.monthly_rate).toFixed(2)}` : ''}</td>
                                            <td>{formatDate(g.move_in_date)}</td>
                                          <td>{formatDate(g.move_out_date)}</td>

                                            <td>{formatDate(g.job_due_date)}</td>
                                          
                                            <td style={{ 'width': "380px" }}>
                                                <a className="btn btn-success btn-sm me-1" href={`/admin/guest-management/guest-intake-form-view/${g.id}`}>View</a>
                                                
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Pagination */}
                    <div className="d-flex justify-content-end mt-3">
                        <nav>
                            <ul className="pagination">
                                {[...Array(pagination.totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${pagination.page === i + 1 ? 'active' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setPagination(prev => ({ ...prev, page: i + 1 }))}
                                        >
                                            {i + 1}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

         

        </div>
    );
};

export default Guest;
